<div class="app">
  @if (!onlyWeb && (displayToSmall | async)) {
    <div>
      <portal-vertise-small [screenWidthInPixel]="minWidthForScreen" />
    </div>
  }
  <portal-header />

  <div
    class="content-wrapper content-wrapper--parallax"
    [ngClass]="{
      'image': hasBackgroundImage$ | async,
      'new-einreichung': isNewEinreichungActive$ | async,
    }">
    <main class="content responsive-row" id="main-content">
      <router-outlet />
    </main>
  </div>
  @if (!onlyWeb && !hideAppVertise) {
    <portal-vertise />
  }
  <portal-footer />
</div>
